module.exports = __webpack_public_path__ + "img/yingxiaoguanli.88efaf89.png";